import React, { createContext, useState, useEffect, useCallback } from 'react';
import { useNavigation as useNavigationBase } from 'react-navi';
import { mixpanelIdentify } from '../utils/analytics';
import { AccountTypes } from '../utils/constants';
import { instantiateMaker } from '../maker';
import PropTypes from 'prop-types';
import {
  checkEthereumProvider,
  browserEthereumProviderAddress
} from '../utils/ethereum';
import LoadingLayout from '../layouts/LoadingLayout';
import schemas from '@makerdao/dai-plugin-mcd/dist/schemas';
import useObservable, { watch } from 'hooks/useObservable';
import useAnalytics from 'hooks/useAnalytics';
import debug from 'debug';

import _ from 'lodash'

const log = debug('maker:MakerProvider');

export const MakerObjectContext = createContext();



function useNavigation(network, mocks) {
  if (network === 'testnet' && mocks) return mocks.navigation;
  return useNavigationBase(); // eslint-disable-line react-hooks/rules-of-hooks
}

function MakerProvider({
  children,
  network,
  testchainId,
  backendEnv,
  viewedAddress,
  mocks
}) {
  const [account, setAccount] = useState(null);
  const [txLastUpdate, setTxLastUpdate] = useState({});
  const [maker, setMaker] = useState(null);
  const [watcher, setWatcher] = useState(null);

  const navNetwork = network === 'kovan-osm' ? 'kovan' : network;
  const navigation = useNavigation(navNetwork, mocks);

  const { trackBtnClick } = useAnalytics();

  // 初始化账户
  const initAccount = account => {
    mixpanelIdentify(account.address, account.type);
    setAccount({ ...account });
  };

  // 退出连接
  const removeAccounts = () => {
    maker.service('accounts')._accounts = {};
    maker.service('accounts')._currentAccount = '';
    setAccount(null);
  };

  // 连接钱包的provider
  const connectBrowserProvider = useCallback(async () => {
    const networkId = maker.service('web3').network;
    const browserProvider = await checkEthereumProvider();

    // 获取账户
    function getMatchedAccount(address) {
      return maker
        .listAccounts()
        .find(acc => acc.address.toUpperCase() === address.toUpperCase());
    }
    // 判断网络id
    if (browserProvider.networkId !== networkId)
      throw new Error(
        'browser ethereum provider and URL network param do not match.'
      );
    if (
      !browserProvider.address ||
      !browserProvider.address.match(/^0x[a-fA-F0-9]{40}$/)
    )
      throw new Error(
        'browser ethereum provider providing incorrect or non-existent address'
      );

    let existingAccount;

    // 判断是否连接
    if (maker.service('accounts').hasAccount()) {
      existingAccount = getMatchedAccount(browserProvider.address);
      if (existingAccount) {
        log(`Using existing SDK account: ${existingAccount.address}`);
        maker.useAccountWithAddress(existingAccount.address);
      }
    }
    if (!existingAccount) {
      log('Adding new browser account to SDK');
      await maker.addAccount({
        type: 'browser',
        autoSwitch: true
      });
    }

    // const connectedAddress = maker.currentAddress();

    const connectedAddress = browserProvider.address;

    // debugger
    return connectedAddress;
  }, [maker]);

  useEffect(() => {
    (async () => {
      // 初始化时设置钱包
      // 初始化设置为metamask
      // if(window.metamaskProvider){
      //   window.ethereum =  _.cloneDeep(window.metamaskProvider);
      // }

      console.log(window.BinanceChain)
      // let isB = window.BinanceChain && window.BinanceChain.isConnected ?  window.BinanceChain.isConnected() : false
      // debugger
      // debugger
      // debugger
      const newMaker = await instantiateMaker({
        network,
        testchainId,
        backendEnv,
        navigation
      });

      // Register multicall schemas and map useObservable hook to watch convenience helper
      const multicall = newMaker.service('multicall');
      multicall.registerSchemas({ ...schemas });
      multicall.observableKeys.forEach(
        key => (watch[key] = (...args) => useObservable(key, ...args)) // eslint-disable-line react-hooks/rules-of-hooks
      );
      // Create and start multicall watcher
      const watcher = multicall.createWatcher({ interval: 'block' });
      multicall.start();
      setWatcher(watcher);
      setMaker(newMaker);

      // debugger

      log('Initialized maker instance');
    })();
    // leaving maker out of the deps because it would create an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backendEnv, network, testchainId]);

  useEffect(() => {

    // 页面初始化时设置钱包对象
    // 需判断是否已经连接以及是否手动退出链接
    // if (sessionStorage.getItem('hasConnected') == 'binance') {
    //   if(window.ethereum){
    //     window.metamaskProvider = _.cloneDeep(window.ethereum);
    //   }
    //   window.ethereum = window.BinanceChain;
    // }
    // console.log(window.BinanceChain)
    // let isBinanceChain = window.BinanceChain && window.BinanceChain.isConnected ?  await window.BinanceChain.isConnected() : false
    // if(isBinanceChain) {
    //   window.ethereum = window.BinanceChain;
    // }
    // 初始化判断
    if (sessionStorage.getItem('hasConnected') == 'binance') {
      if (window.ethereum && window.ethereum.isMetaMask) {
        window.metamaskProvider = _.cloneDeep(window.ethereum);
      }
      window.ethereum = window.BinanceChain;
    } else {
      if (window.ethereum && window.ethereum.isMetaMask == undefined) {
        window.ethereum = _.cloneDeep(window.metamaskProvider)
      }
    }

    // debugger

    if (!maker) return;
    if (maker.service('accounts').hasAccount()) {
      // debugger
      initAccount(maker.currentAccount());
    } else {
      // Reconnect browser provider if active address matches last connected

      console.log(sessionStorage.getItem('hasConnected'), 'fksession')




      // 需要改进的地方
      if (sessionStorage.getItem('hasConnected') !== 'binance' || navigation._history.location.pathname.includes('owner/') || navigation._history.location.pathname.match(RegExp("[0-9]"))) {

        // debugger
        const lastType = sessionStorage.getItem('lastConnectedWalletType');
        if (lastType === 'browser') {
          const lastAddress = sessionStorage.getItem(
            'lastConnectedWalletAddress'
          );
          browserEthereumProviderAddress().then(activeAddress => {
            if (activeAddress === lastAddress) {
              log(
                `Reconnecting address: ${activeAddress} (matches last connected wallet address)`
              );
              connectBrowserProvider();
            }
          });
        }
      }
    }


    // debugger

    // 监听连接变化
    maker.on('accounts/CHANGE', eventObj => {
      const { account } = eventObj.payload;
      if (eventObj.sequence === 1)
        trackBtnClick(undefined, { fathom: { id: 'connectWallet' } });
      sessionStorage.setItem('lastConnectedWalletType', account.type);
      sessionStorage.setItem(
        'lastConnectedWalletAddress',
        account.address.toLowerCase()
      );
      // debugger
      log(`Account changed to: ${account.address}`);
      initAccount(account);
    });

    // debugger

    const txManagerSub = maker
      .service('transactionManager')
      .onTransactionUpdate((tx, state) => {
        if (state === 'mined') {
          const id = tx.metadata?.id;
          if (id) {
            log(`Resetting event history cache for Vault #${id}`);
            maker.service('mcd:cdpManager').resetEventHistoryCache(id);
            setTxLastUpdate(current => ({ ...current, [id]: Date.now() }));
          } else if (tx.metadata?.contract === 'PROXY_ACTIONS_DSR') {
            log('Resetting savings event history cache');
            maker.service('mcd:savings').resetEventHistoryCache();
            setTxLastUpdate(current => ({ ...current, save: Date.now() }));
          }
        }
        log('Tx ' + state, tx.metadata);
      });


    // debugger

    return () => {
      txManagerSub.unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [maker, connectBrowserProvider]);

  const connectToProviderOfType = async type => {
    if (!maker) return;
    if (maker.service('accounts').hasAccount()) {
      initAccount(maker.currentAccount());
    } else {
      const account = await maker.addAccount({
        type
      });
      maker.useAccountWithAddress(account.address);
    }
    const connectedAddress = maker.currentAddress();
    return connectedAddress;
  };

  const disconnectWalletLink = subprovider => subprovider.resetWallet();
  const disconnectWalletConnect = async subprovider =>
    (await subprovider.getWalletConnector()).killSession();
  const disconnectBrowserWallet = () =>
    ['lastConnectedWalletType', 'lastConnectedWalletAddress'].forEach(x =>
      sessionStorage.removeItem(x)
    );

  const disconnect = () => {
    const subprovider = maker.service('accounts').currentWallet();
    if (subprovider.isWalletLink) disconnectWalletLink(subprovider);
    else if (subprovider.isWalletConnect) disconnectWalletConnect(subprovider);
    else if (
      sessionStorage.getItem('lastConnectedWalletType') ===
      AccountTypes.METAMASK
    )
      disconnectBrowserWallet();
    removeAccounts();
    // 退出时还原metamask钱包对象
    // 把连接状态干掉
    if (window.metamaskProvider) {
      window.ethereum = _.cloneDeep(window.metamaskProvider);
    }
    sessionStorage.removeItem('hasConnected');
  };

  return (
    <MakerObjectContext.Provider
      value={{
        maker,
        watcher,
        account,
        network,
        txLastUpdate,
        connectBrowserProvider,
        connectToProviderOfType,
        disconnect,
        viewedAddress,
        navigation
      }}
    >
      {maker ? children : <LoadingLayout />}
    </MakerObjectContext.Provider>
  );
}

MakerProvider.propTypes = {
  network: PropTypes.string.isRequired
};

export default MakerProvider;
